module.exports = __webpack_public_path__ + "img/26.d55de98c.jpg";